import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { NotificationRulesState } from '@reducers/notification-rules';

export const getNotificationRules = (state: RootState): NotificationRulesState => state.notificationRules;
export const getNotificationRulesData = createSelector(getNotificationRules, (rules) => rules?.data);
export const isNotificationRulesLoading = createSelector(getNotificationRules, (rules) => rules?.loading);
